module.exports = __webpack_public_path__ + "img/consult_info2.777e0703.png";